// CÓMO SE LLAMA EL INFORME DE UN REPORTE, SEGÚN SU TIPO (13-10, hoja de los probadores, M7).
//
// En la ficha del equipo, al abrir un reporte, el bloque del informe se titulaba siempre
// "Informe del mes", también en un quincenal. El informe es el del reporte que se abre: el
// del mensual es el del mes, y los otros se llaman como su reporte. El tipo viaja en el
// reporte desde el 4-09; los de antes no lo llevan y se quedan en "Informe" a secas.
//
// Son las mismas palabras que ya lee el cliente en su historial de reportes ("Ver mi
// informe quincenal", "Ver mi informe del mes": `pages/ReportsPage.jsx`).
const NOMBRE = {
    mensual: 'Informe del mes',
    quincenal: 'Informe quincenal',
    semanal: 'Informe semanal',
};

export const nombreDelInforme = (tipo) => NOMBRE[tipo] || 'Informe';
